import { cn } from "@/lib/utils"

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg"
  className?: string
}

export function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6", 
    lg: "w-8 h-8"
  }

  return (
    <div
      className={cn(
        "spinner border-2 border-gray-300 border-t-primoup-500",
        sizeClasses[size],
        className
      )}
    />
  )
}

interface LoadingProps {
  text?: string
  className?: string
}

export function Loading({ text = "Caricamento...", className }: LoadingProps) {
  return (
    <div
      className={cn("flex items-center justify-center p-8", className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center space-y-4">
        <LoadingSpinner size="lg" className="shrink-0" />
        <p className="text-muted-foreground">{text}</p>
      </div>
    </div>
  )
}

interface LoadingOverlayProps {
  isLoading: boolean
  text?: string
  children: React.ReactNode
}

export function LoadingOverlay({ isLoading, text = "Caricamento...", children }: LoadingOverlayProps) {
  return (
    <div className="relative">
      {children}
      {isLoading && (
        <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-50">
          <div className="flex flex-col items-center space-y-4">
            <LoadingSpinner size="lg" />
            <p className="text-muted-foreground font-medium">{text}</p>
          </div>
        </div>
      )}
    </div>
  )
}

